<template>
  <app-icon-button :label="loading ? 'Refreshing…' : 'Refresh'" tooltip-placement="left" :disabled="disabled || loading" :aria-busy="loading ? 'true' : 'false'" @click="$emit('click', $event)">
    <i class="pi pi-refresh" aria-hidden="true" />
  </app-icon-button>
</template>

<script>
import AppIconButton from './AppIconButton.vue'

export default {
  name: 'AppRefreshButton',
  components: { AppIconButton },
  props: { loading: Boolean, disabled: Boolean }
}
</script>

